function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.24059 8.93097C6.75051 6.98167 3.96468 6.6076 2.01826 8.09547C0.0718404 9.58335 -0.298095 12.3697 1.19199 14.319C2.68207 16.2683 5.4679 16.6424 7.41432 15.1545C9.36074 13.6667 9.73067 10.8803 8.24059 8.93097ZM6.47855 10.278C7.22359 11.2526 7.03863 12.6458 6.06542 13.3898C5.09221 14.1337 3.69929 13.9467 2.95425 12.972C2.20921 11.9974 2.39418 10.6042 3.36739 9.86025C4.3406 9.11631 5.73351 9.30334 6.47855 10.278Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.7164 9.01913L5.50459 7.93844L14.6629 1.10677L16.0001 2.85604L7.7164 9.01913Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13.8386,
  y: 7.2796,
  width: 3.30272,
  height: 2.20181,
  transform: "rotate(-127.395 13.8386 7.2796)",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 11.7024,
  y: 9.92316,
  width: 4.10554,
  height: 2.20181,
  transform: "rotate(-127.395 11.7024 9.92316)",
  fill: "currentColor"
});

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.e0a2571b.svg";
export { ForwardRef as ReactComponent };